import Backbone from 'backbone';
import { format } from '../../../home24-shared/core/Utils';

export default Backbone.Model.extend({
  defaults: {
    index: '',
    ownAddress: false,
    suggestedAddress: false,
    street: '',
    streetNumber: '',
    streetAdd: '',
    zip: '',
    city: '',
    country: '',
    full: ''
  },

  toString: function(skipStreetAdd) {
    var streetAdd = '';

    if (!skipStreetAdd) {
      streetAdd = this.get('streetAdd')
        ? ' ' + this.get('streetAdd') + ','
        : '';
    }

    return format(
      '{0}, {1},{2} {3}',
      this.get('zip') || '',
      this.get('street') || '',
      streetAdd,
      this.get('city') || ''
    );
  }
});



/** WEBPACK FOOTER **
 ** ./legacy/home24-desktop/helpers/addressCheck/addressCheckAddressModel.js
 **/